import axios from "axios";

const api = axios.create({
  // baseURL: "https://automatch.ie/api",
  // baseURL: "http://localhost:8000",
  // baseURL: "http://localhost/php_AutoMatcher/api/",
  // baseURL: "https://vehiclespecs.bharmalsystems.net/api",
  baseURL: process.env.REACT_APP_BASE_URL + "/api",
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("api_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default api;
